module.exports = __webpack_public_path__ + "static/media/dSlider1.56ba5cec.png";